import React, { Component } from 'react';
import CTCAE_ROW_DATA from '../../../resources/ctcae6';
import { FormControl, FormGroup } from 'react-bootstrap';
import Result from '../result/result';
import './search.css';

class Search extends Component {

    constructor() {
        super();
        this.state = {
            step: 0,
            total: 0,
            code: undefined,
            keyword: undefined
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSelect(e, code){
        console.log('handleSelect is called', code);
        this.setState({
            step: 1,
            code: code
        });
    };

    handleBack = event => {
        this.setState({
            step: 0
        });
    };

    render() {
        let infoListView = null;

        const keyword = this.state.keyword;
        if(this.state.step === 0 ){

            if(keyword){
                const regexKeyword = new RegExp(keyword, 'i');
                const filteredList = CTCAE_ROW_DATA.filter(data => (data.meddra_soc.match(regexKeyword)
                    || data.meddra_code.toString().match(regexKeyword)
                    || data.ctcae_term.match(regexKeyword)
                    || data.grade_1.match(regexKeyword)
                    || data.grade_2.match(regexKeyword)
                    || data.grade_3.match(regexKeyword)));

                console.log(keyword, filteredList);

                let self = this;
                if(filteredList.length > 0){
                    const total = filteredList.length;
                    infoListView =
                        (
                            <div>
                                <div className="title">
                                    Search results ( Total : {total} )
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover">
                                        <tbody>
                                            <tr>
                                                <th>No</th>
                                                <th>Meddra Code</th>
                                                <th>Soc</th>
                                                <th>Term</th>
                                            </tr>
                                            {
                                                filteredList.map(function(item, i){
                                                    return (
                                                        <tr key={item.meddra_code} onClick={(e) => self.handleSelect(e, item.meddra_code)}>
                                                            <td>{i+1}</td>
                                                            <td>{item.meddra_code}</td>
                                                            <td>{item.meddra_soc}</td>
                                                            <td>{item.ctcae_term}</td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        );
                }
            }


            return (
                <div className="search-content">
                    <div className="content-body">
                        <div className="col-sm-3 col-xs-12 search">
                            <div className="title">
                                <div>Search</div>
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div>
                                <form>
                                    <FormGroup className="row" controlId="keyword">
                                        <div>
                                            <FormControl
                                                type="text"
                                                placeholder="keyword"
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                    </FormGroup>
                                </form>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="list">
                                {infoListView}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }else if(this.state.step === 1 ) {

            const result = CTCAE_ROW_DATA.filter(data => (data.meddra_code === this.state.code))[0];

            console.log("final result : ", result);

            return (
                <div className="main-content">
                    <div className="row content-header">
                        <div className="col-sm-3">
                            <div className="title">
                                <button className="btn btn-default" onClick={this.handleBack}><i className="fa fa-arrow-left"/> Back to results</button>
                            </div>
                        </div>
                    </div>
                    <div className="content-body">
                        <Result result={result}/>
                    </div>
                </div>
            );
        }
    }
}
export default Search;


// WEBPACK FOOTER //
// ./src/component/ctcae6/search/search.js